// src/data/branchCustomers.js

export const BRANCH_CUSTOMERS = {
  AGONA: [
"RICHARD NANA MENSAH", 
"Esther Appoh",
"Mickeyrine Ventures",
"Helena Cudjoe", 
"Robert Ben Gaisey",
"Mose Mensah Aboagye",
"Mose Akugre",
"Beatrice kesson",
"Bessman Ventures",
"DK-Yirenkyi",
"Infinity innovation",
"Generosity Communication", 
"Brace ventures ",
"Honour The King",
"Time Heals Chop bar Tarkwa", 
"David Kwabena Kwofie Ent",
"Sac 3 logistics", 
"Nador Victor Ventures", 
"LA PERIE GRAFFICS ENTERPRISE", 
"Becky Ventures", 
"Sheek Ventures", 
"Master mind Ventures", 
"Rahtifa Enterprise", 
"Gate Capital Plus 2", 
"Alex D pendable",
"Kafupo Enterprise",
"Godlife Adjei Solomon enterprise", 
"Judycem Enterprise Agona Nkwanta", 
"Ronaldo Ent",
"E-BONITO ENT", 
"Senior Joseph Business Center", 
"Nana KWAW Enterprise", 
"God is Able Ventures", 
"Agyenim Boateng Ent",
"Shall Gold Ventures",
"God is Good", 
"MM Seventy Three  Western WR REG",
"Showers If Grace Enterprise", 
"Gloria Ventures",
"Pat Richy Ventures", 
"The Most High", 
"Kob Gyasi",
"Ahmed Yankey Enterprise", 
"Bullet Zone Business zlink",
"GADDE YOU THINK ENTERPRISE",
"Ellebright ventures",
"ICELLHUB ENTERPRISE",
"Archer  Paul Kesse",
"Lynn's ventures",
"FRABERNICK VENTURES", 
"Dominic Adolwini Atibila",
"Ali Shaibu 92 Ventures",
"Allah Is The Greatest",
"DORBUDU VENTURES",
"GIDEONLIT VENTURES",
"FOSA 98",
"Nyame Ahomobro", 
"MM 77 WESTERN REGION", 
"Arngeof Ventures", 
"Don Ziggy Ent-Simon Appiah Cudjoe",
"Nicholas Acheampong Enterprise", 
"Gideon Kofi Prah",
"Emma Greate",
"Richard Okyere nyarkoh", 
"Capitano ventures",
"Leticia Sowudu",
"Ellebright ventures1", 
"Ambient Electricals",
"Kingshoot2 ventures",
"ERIFRACE",
"TETMARG HONESTLY ENTERPRISE", 
"Obed Quaicoe",
"Miqasant star ventures",
"Linda Leonie Abakro",
"Lee- Eagle Enterprise one",
"Priscilla Ama Kwofie",
"Veronica Prah",
"ENNIN VENTURES-Lydia",
"Charles kojo -Rock 2 Ventures",
"God’s Gift Communication-lUCAS",
"JQ REAL SOLUTIONS-Ebenezer",
"Ismaela Jebril",
"HERMAN SARBENG ASEBRESE-Millicent",
"EVANS KONLAN-Eva Konla",
"Chadis-Q Ventures",
"Nyameous Lucky Ventures-Robert",
"Emmanuel Ansah-Mobe Ka me",
"Vera Amekor-COMFORT BAID",
"Blessed Benedict Enterprise",
"Ebenezer Mungoh-Mungoh Enterprise",
"Rans Ventures -Ransford Quarshie",
"Janet Annane Enterprise -Charity Asare",
"Benzito Electricals - David K Mensah",
"Albie 2022 Ventures - Alberta Mensah",
"MAGBEE ENTERPRISE - Margaret Mensah",
"Jues Ent", 
"Ecophlia Ventures - Ophelia Akosua Brago",
"IKE VENTURES - Isaac Mensah",
"Job Jaabs Ventures - Samuel Bamfo",
"Precious Otuwah - S .BON",
"Samuel Owusu - In him is life",
"Wack Two Ventures-Gifty Danso",
"Philip 87 telecom -Philip Egyrenyi",
"Richie Morris ventures -Richard Oboh Morrison",
"Emelia Effah Ventures -Emelia Effah", 
"Agrich Enterprise-Agrich Enterprise", 
"Burry Money - Rudolpha Ashiagbor",
"Afodick Ventures -Edward Obeng Ofosu",
"Cobbinah - David",
"Navame Ventures -Godfred Essah",
"Amediku Ventures -Daniel Amediku",
"Self Made Entertainment -Joel Bankom", 
"Obed K Enimah Telecom-Obed Enimah",
"Agirich Enterprise -Agnes Essien",
"Cash man Ventures -Kofi Ansah",
"God is My Hope -Rosemary Ama Yalley", 
"Reckey Impex ventures -Stephen Appiah", 
"VR-OTI MPOS ACCESS 028 -Janet Quansah", 
"Nhyira Nka Nyame -Faustina Tobah",
"Seth Arhin	ADS VENTURES", 
"Samuel Amankwah -Psalm 81:1",
"Emmanuel Andoh Nadnesy Ventures", 
"David Prah David Prah",
"Esther Appoh He Can He",
"Mary Asante Mary success", 
"Daniel Acquah 	Big Dan Acquah",
"Elijah Basiemah-Rise up Again", 
"Frank Say	Frank Say",
"Bernard Gyan-Gyandolf Enterprise",
"Emilia Effah Ventures 	Emilia Effah",
"Adonai Business Centre Adonai Business Centre",
"John Alex Nzeh	C6C Enterprise", 
"Jamal Majeed -Jamaica Plus Enterprise",
"Jude Addae Jude .A 0800 Ventures", 
"Leticia Kwofie Fovour From God",
"DICKSON ALOYSIUS -ADS VENTURES",
"Solomon Opoku 	The Games2 Ventures",
"Solomon Opoku 	The Games1 ventures",
"Richard Adjei 	Third Exodus ventures", 
"Juliet Kwaku	Juliet Kaku Enterprise",
"Benjamin Narh Tetteh 	Benjamin Narh Tetteh", 
"Bismark Yilaku Essuman	Ess- Bisani Enterprise",
"Hawa Dawida -Made with Hawa",
"Enoch Ocran -Enochus Design", 
"Fred Attivor-Matrust Ghana Limited", 
"Roger Osei Tutu -Roger Osei Tutu",
"Ebenezer Gyan 	Priceless enterprise",
"Philip Egyrenyi 1	Philip 87 Telecom1",
"Gifty Banso Adonai Business Centre",
"Solomon Quayson Solomon Quayson",
"Solomon Cobbinah SOLO ROYAL VENTURES",
"Daniel Mensah 	Danvick ventures",
"Ebenezer mungoh Mungoh enterprise2",
"Frank Twumasi 	Chrestos Call",
"Juliet Kaku -Juliet Kwaku Enterprise",
"Joshua Nyame Essien Time Heals Chop Bar",
"Julius Bosque-Hamilton	JBH Topline Ventures", 
"Precious Otuwah -S- Bon Enterprise", 
"Samuel Donkor 	Donsam Servicing And Spa are Partss",
"Edward Karikari -Katos-Eddglo Ventures",
"SHEDRACK MINTAH	GOD IS GOD IS GOOD",
"ATTA AGYEMAN	ADOM ARE KWA VENTURES", 
"Jechoriah Dartey	Jechoriahs Success Enterprise", 
"Francis Obeng 	Trust and Hope Ventures", 
"Gordon Atongo Aduah -Jemaca Guy",
"Daniel De- Graft	Danzibite Mindset",
"Paulina Bessaw -Lines Enterprise",
"Onyameos -Onyameos",
"Edikanfo -Edikanfo",
"Paulina -Linbes Ent",
"Paulina Aidoo	Eagle Time Enterprise",
"Emmanuel Kwame Yankey 	MELYANKEY",
"Daniel Acquah 	Big Dan Acquah", 
"Jacob Dadzie 	Jacob Well Enterprise", 
"Justice Ansah 	Just Ansah",
"Salifu Musah	Salifu Musah",
"Christabel Arbenser -Christabe Arbenser enterprise", 
"Emmanuel Bonney -E-BONTO",
"Emmanuel  Junior Vision Selase -Vision Ventures", 
"Richard Lamptey -360 Phones",
"Moses Asare -Mother's Love",
"Ruth Mensah Ruthmic Verse",
"Michael Fynn-Michael Fynn",
"Sackey Gifty -Swift Cleaning Service", 
"Navame Navame Ventures", 
"Alex Kwofie -AlexKwofie",
"Eric Baidoo -Erico Godfirst money Second vent",
"Anthony Nyameboom Aikins -Edikanfo Nhyira Company", 
"Ruth -RUTHMIC",
"Salifu Musah -Salifu Musah",
"Richard Nyarko -Richard Nyarko",
"Wisdom -Eagle time ventures 1",
"Fredrick -Fredo unique Business Centre",
"Anthony K Eshun -Blessed Virgin Mary",
"Priscilla Anlimah -Jeohard Ventures", 
"Arthur Millcent -AM Enterprise",
"Samuel Ansah -Ansah Paradise", 
"Nevame Ent -Nevame Ent",
"Sebuabey Godfred Eden -Sebdem Ventures", 
"Pauline Aidoo 	Eagle Time Ent @ Anchiyie",
"Augustina 	Augustina 1990 Ventures",
"Prince Henry Essien Henry - Paa Ventures",
"Rita -Papa Mo wo hon",
"Priscilla -Joehard Ventures", 
"Alma -Alma Ventures", 
"Jechoriahs -Jechoriahs success ent",
"Samuel Ansah -Ansah Paradise",
"Leticia Kwofie -Favour From God Ventures", 
"Prince Henry Essien -Henry-Paa Ventures",
"Paulina Amissah -Polyamass Ventures", 
"Fredrick Oheneba Quaisie -Fredo Unique Business Center",
"Joshjenny ventures -joshjenny ventures", 
"Benjamin Awni Anaba -Benjamin Awuni Anaba",
"Papa Yamson -Paapa Yamson",
 "Alley Ventures -Alley Ventures",
"Henry-paa Ventures-Henry-paa",
"Joshjenny ventures -Joshjenny", 
"C6C VENTURES -C6C VENTURES",
"Allah is the greatest -Allah is the greatest",
"Benjamin Awuni Anaba -Benjamin Awuni Anaba",
"Ritmens 555 enterprise -Rita Mensah",
"Star Horse -Star Horse",
"Janet  Abbey -Janet Abbey",
"Papa ma ho Enterprise -Paa ma ho Enterprise",
"Kate De Queen Ventures -Kate Ayertey",
"Amazing Dankwa Ventures -Emmanuel Dankwa",
"Andrew Agyeimin Boateng -Andrew Agyeimin Boateng",
"Sherif Dauda -Sherif Duada",
"Belinda Kwofie -Foslin Investment",
 "Eric  Business Centre -Eric Business Centre",
"Time and Chane	Time and Chance",
"Lazarus Quayson -Lazarus Quayson Ventures",
"John Kofie Tetteh -John Kofi Tetteh",
"James cobbinah 	Jamcobb Enterprise", 
"Ezekiel Arhensah	Ezekiel Arhensah Enterprise",
"Maxwell Bagna Avatim	Maxmat Ventures",
"Ophelia  Ntriakwa	Ophelia Ntirakwa",
"Constance Ebbi	Lily Enterprise",
"Appiah Kwesi	Appiah Kwesi",
"Ewurade Naye 	Ewurade Naye",
"Vicent Zoeyeuf	Zoeyeuful Ventures",
"Time and Chance 	HMT Time and Time",
"Obed Tuffour 	Mackwini Ventures",
"Defended by Jehovah 	Defended by Jehovah",
"Obolo facitiy	Obolo Facitiy",
"WI Johnboy 58 Enterprise 	John wumboprche",
"Only Jehovah bless Michael  Nyarkoh",
"Philip telecom3 -Philip Egyrenyi",
"Emefa POGAS faustina Emefa Dam",
"Rock Two Ventures2	Rockson Charles kojo", 
"Grace Asare -Am Done Business Links",
"Desmond Quarm Ventures Desmond Quarm Ventures",
"Yalley Ventures Yalley Ventures",
"Shopify Ventures Shopify Ventures",
"Emmanuel Lamptey -Award Winner",
"Arena Kojo Apentu	Arena Series",
  ],

  BAKAEKYIR: [
    "Sally Smith-Ansah", 
"Mary chea Enterprises", 
"Veesa Enterprise", 
"Boss Lady Glamour", 
"Stanforn Ventures",
"Zizu Ventures",
"Uhan Enterprise", 
"Olu Winters Enterprise", 
"Wunfara Enterprise", 
"I told you Ventures Emelia Nuamah",
"Esmeral Linda I told you ventures",
"Wilcho Garment", 
"Benedicta Nyanko Enterprise", 
"New Guy Ventures",
"Masiratu Debrah Ventures", 
"Kingsaford Enterprise", 
"Ama backstone Ventures",
"Caplife Limited",
"Frederick Nuba -Sammet Ventures",
"Abdullah Suleman-Marshalla enterprise",
"Emmanuel Hammond -EH PLUS VENTURES",
"Reuben Nchor- Reuben Nchor Ventures",
"Agnes Arthur -Hobby lobby",
"Patricia Whadjah-CV Dot Com",
"Mercy Nyuwan -Perez Ventures", 
"Josephine Tachie Mensah -Ellen White", 
"Pearl 	Shalom Unit", 
"Fizza Quayson -Fremas venture’s", 
"Blessings Adusei -Complet Empire Ventures", 
"Belinda Mensbre Ventures",
"Edith Koomson 	Vivian Awuku Ventures", 
"Fati	Abdula Fati 1997 Enterprise", 
"Priscilla Addo	Pricby ventures",
"Rita Nunu -Preference Ventures",
"Patricia Annamah -Patricia Annamah Ventures",
"By His Grace Ventures",
"GLANENT ENTERPRISE",
"SACRED TRINITY VENTURES",
"JISWEPT ENTERPRISE",
"LEEN’S DELISH ENTERPRISE",
"Ezecom Business links	EZECOM",
  ],

  ELUBO: [
    "Gabiko Ventures",
"Pris Ab Ventures",
"Be-Gentle Enterprise",
"Queenzy Enterprise",
"Dzefe Sam Enterprise",
"M-Silas Ventures",
"Dans Laundry and dry cleaning Ventures",
"Rappart Connerx Enterprise", 
"Albert Eduku -DC Noble Ventures",
"Nanatel LTD -Nanatel LTD",
"Bencomm 44 Ventures",
"Adu Christiana Ventures",
"Peter Edue -Peter Edue",
"Sanaki Enterprise",
"Jane Tsey Ventures",
"Dwumarhlos Enterprise",
"Sanaki Enterprise 	Sanaki Enterprise",
"Jane Tsey Ventures	Jane Tsey Ventures",
"Sir Apolo Enterprise",
"Bijay Ventures",
  ],

  AXIM: [
     "R.C ELECTRICALS",
"Born Rich Ent",
"Bilal phones and Accessories", 
"Ohemaa Mercy Ventures", 
"LIFE IS WAR ENTERPRISE",
"New day, new life enterprise", 
"22kobby brains", 
"Kwame Fosu enterprises", 
"New ventures", 
"One man no chop",
"One man no chop",
"Awake diamond ventures", 
"K- Konsult",
"Justice Arthur", 
"Isaac Andoh Ventures", 
"Success is on door Enterprise", 
"Mohammed Ayuba Enterprise", 
"By the grace of Allah", 
"Randsbecca enterprise", 
"Philomena awortwe", 
"SERIOUS PEOPLE ENTERPRISE", 
"WHO KNOWS TOMORROW",
"OBED NYAMEYIE ENTERPRISE", 
"B- Frank Electricals", 
"ESTHER QUANSON",
"Sam Passion Ventures", 
"GEAWORNU MIRCOFINANCE SERVICE",
"Richmen enterprise", 
"Big Dan Ventures", 
"JUSTINA'S BUSINESS LINKS",
"Enock Ngedah",
"Katuso ediko ventures", 
"Ennin ventures",
"Experience is the best Bernard ventures",
"CATHERINE QUASIGAH",
"God Empire Enterprise", 
"New day , new life Enterprise",
"Star Alluminum Service", 
"U-link ventures-Timothy Ansah",
"NICOLAS NICOLAS-RICK AND NICK",
"EMMANUEL FOSU ENTERPRISE",
"COMFORT MENSAH -CMENS",
"Francis Gyaben	Victory Assured",
"Priscilla Ackah 	Priscilla Ackah Pela’s Enterprises",
  ],

  ESIAMA: [
    "Christopher kaku- TSA VENTURES",
"JOHN ASHI	Jesus is Lord  is vets",
"Emmanuel Blay	Emmanuel Blay",
"Francis Anaman	Rev Francis ent",
"FRANCIS KWASUBLAY	ADOM ENTERPRISE", 
"JACK BLAY	JACK BLAY ENTERPRISE",
"FRANCIS JACKSON KAKU 	JOE ONE",
"JOHN EFFERH- Big Stephen mobile money cente",
"STANISLAS ASSIDOE.OFORI -OFORI TELECOM",
"Patrick anglow	Anslow -phone anglow Patrick",
"EBENEZER 	Hello Vivian",
"TABI DORIS OWUSUWAA DORIS OWUSUWAA BUSINESS", 
"Patrick  Nyanzu -X MAN Ent",
"PATRICIA  NREDAH -MAMA PAT",
"JOSEPH KWAME 	NEVER RUSH ENTERPRISE",
"Mwin Nadie Ent	Jerry hudi",
"LYDIA ANLIMAH 	Achieese VENTURES",
"BARNABAS HACKMAN-EQUILIBRIUM PRICE ENTERPRISE", 
"LYDIA AYAABAH 	Grace over Disgrace trading ent",
"ROSEMARY EWEROKO-Mr Osei Click ventures",
"JOHN BEYELAH -Almighty Phones",
"KAYAH VICTORIA XLNC MULTIMEDIA 1",
"FRANCIS KWOFIE FRANCIS KWOFIE",
"Mama Lee -Lydia Alladan",
"Divine Favour of God-Stephen Cudjoe",
"JOE MAY ENTERPRISE JOSEPH ALLAH AMODZIN",
"YAKUBU ABDULAI ELSOM VENTURES",
"SAMUEL NYANKO 	THOUGHTFUL CHILD", 
"FUSEINI NUHU -GOD IS GOOD VENTURES", 
"ISRAEL CHRIS KAKUO DERBY-DE JONES COMPANY LTD",
"DANIEL QUARM ARTHUR -CLASSIC ENTERPRISE",
"ABRAHAM BAIDOO	CHRISTLOVE JANITORIA",
"BRIDGET AGYEMANG BRIDGET AGYEMANG",
"LAWRENCE KAKU AGYILE-LAWKAK VENTURES", 
"19 ENTERPRISE	FRANCISCA",
"PRECIOUS KWASI Western South momo agent 73",
"ELIZABETH COBBINAH -LIZZY'S GREAT ENTERPRISE",
"QILVE VENTURES	Douglas Arize",
"GRACE CUDJOE -GREAT SAMDAVE ENTERPRISE",
"CHRISTOPHER ANNOR MIEZAH	STAGNATION ENTERPRISE",
"ISAAC SACKEY-RABBAT VENTURES",
"LITICIA.ARIZI	DE TECH ELECTRONIC",
"CHARLES BAAH	HOLY AND PHOTO AND BUSINESS CENTER",
"AUGUSTINE DAUDA NEW PALACE 1989 VENTURES",
  ],

  "VOL-MAGT": [
      "Totleman ventures-Margaret",
"Arde Enterprise -Florence",
"Sam Duah VENTURES -", 
"JEHOVAH PROMISE- Joseph", 
"E.K DESTINY DREAMS ENTERPRISE - Elizabeth", 
"Mind You VENTURES -Stephen",
"Mary Amakye -Macmillan Acquah Real Estate",
"Kate kumah	- God bless Enterprise",
"Alijah fosu - Ally's	Jehovah Grace venture",
"EMMANUEL Yegoe - DIVINE CAPTAIN",
"William Mensah - Phone beat Accessories", 
"Paul Eric - mbir Paulbir",
"Sabina Esi Cobbina	-Sabina Esi Cobbina Enterprise", 
"Gabriel  Mensah -Gabriel Mensah G and G7",
"Innocent Gakuo	Innocent Jewellery",
"Deborah Arthur -DEBBIE SPARLING ENTERPRISE",
"Theresah Cobbinah	THERESAH COBBINAH",
"Matilda Baidoo	-YABAMAYS ENTERPRISE",
"Phihans Enterprise -Phihans Enterprise", 
"Adusu patience -Kalee CATERING", 
"Albert Asare -Asare mavis",
"Thomas mensah	Wasmac media consult",
"Ezekiel Ackah	Ezecom business links", 
"Isaac Afriyie manso -Aim to Succeed",
"Samuel nana cato - Samuel nana cato",
"Dora Kasu	Samtuga 66 ventures",
"JONATHAN BIJAKIN KOMBAT-JONATHAN KOMBAT VENTURES", 
"Joyce	CARTY JOEJOY ENTERPRISE", 
"Isaac kofie sylveter -Isaac kofie sylveter",
"RICHARD FAMOUS -FAMOUSON VENTURES",
"Comfort Afari -Solcom21",
"Gladys Nyamson cudjoe	GLADMART ENTERPRISE", 
"Veronica miezan -Miezan Roni business centre",
"Naomi Joelyna Adjei-ADORAJOE CO.LIMITE",
"Bertrice -PAA CONTI MARKETING",
"Dorcas Dwyku	ESLDORS VENTURES",
"YETTEY CHRISTINA -Bedzira Wisdom",
"Charlotte Boadu -KWAME OWUSU TUFFOUR ENTERPRISE", 
 "TAYOWA venture-TAYOWA venture",
"Moreen Enyonam	J.BIO ENTERPRISE", 
"IAS CASHPOINT VENTURES IAS CASHPOINT VENTURES", 
"EDWARD BORTSIE  EDWARD BORTSIE EDDBORT VENTURES", 
"Amezugbe James	JAMES AMEZUGBE JAMBERT VENTURES", 
"Evans kojo fosu -Evans kojo fosu Enterprise", 
"BETTY VEER	ZUBET SMARTCHOIZ ENTERPRISE", 
"Helena -ZAZOR VENTURES",
"ADORVLO WILLSON ADORLVO WILLSON",
  ],

  "TYPE-C": [
    "Emmanuel tetteh-Gyenyame",
"Mike licia money ventures",
"Evies Whelimina Doddo",
"Zamien Enterprise 	Zamien Enterprise",
"Jah over everything -Lydia",
"TriniAlpha	Florence Quaicoe",
"Florence Quicoe -Trini enterprise",
"Jah over everything -Jah over everything",
  ],

  KOJOKROM: [
    "Patience Cobbinah 	Scaffold Messiah",
"Aaron Kennedy 	De - Appiah Yankom Enterprise", 
"Rita Mensah -Khakis Child Ritash Enterprise", 
"Charity Akpabli -Olivia Jes Enterprise",
"Kweku Appiah -The OC's Catering Services & Rentals",
"John Arthur -Kalascom Ventures", 
"CHRISTABEL KUKUA NYANKSON- Kept By The Power of God",
"Eric Appiah Kubi	Josariak Business ventures",
"Daniel Gifty Joeboy Nartey	-Stemphather Enterprise", 
"Dorothy Awortwe -Beautiful Doro ventures",
"David Eduaquah	Benquah ventures",
"Ignatius Nandome -SUNREY ENTERPRISE",
"Rebecca Ocran	Timkum Enterprise",
"Seidu Abdul Nafiwu	Sandy's travel consult",
"Madina Abdul Salam	Malik Ventures",
"Benedicta Nyarko	Benedicta Nyarko Enterprise", 
"BEN-DEES VENTURES 	DINA ABA QUANSAH",
"Assafuah  Josephine -Subilove business pub",
"Bisamrk	Botchway",
"Bob Nvida Amoako	Bobif Enterprise",
"Bob Nvida Amoako	Bobif Enterprise",
"Uhanasu Haruna	Uhan Enterprise",
"Patricia whajah -CV Dot com",
"Priscilla Attua Addo -Priscy Bee ventures",
"Desmond sapak	Trust the process limited",
"Anastasia  -As promised ventures",
"Solomon Andorful	Solomon Andorful Enterprise",
"Desmond	Beat winners Enterprise",
"Paa Sammy Business Solutions",
  ],

  "ANAJI-K": [
    "Dadzie dadzie Ent",
      "David ainoo ST Padua Ventures",
      "DANWIN VENTURES",
      "Victory Enterprise",
      "Elizabeth Ansah",
      "Blessing Evelyn kinnah",
      "Deborah Addae Debbyliz Ventures",
      "Patrick  kizito botsio",
      "Joshua Anaman 90",
      "ELSOM VENTURES",
      "Powerful  saviour-Patrick kizito botsio",
      "ST Padua Ventures-David Ainoo",
      "DEBORAH ADDAE",
      "Joshua Anaman  Enterprise",
      "Charles Yankey  cy Telnecom",
      "Allawakubur Ventures- Hawa",
      "MAX POLY PRODUCTS",
      "Godfred Fuachie SRC Ventures",
      "Pepassin Enterprise - Millicent",
      "Fatimah logo AL Wakerley F .J Enterprise",
      "VIda Amoah Zeetonia Ventures",
      "Isaac Born to win",
      "JustBee Ventures - Gifty Baffoe",
      "Ebenezer Ackon Ent-Isaac opoku",
      "Zinabu Halidu-Paul is able",
      "RHODA MENSAH-Rhodwusu",
      "Kofi dream big-Anthony",
      "Amamata sadick Enterprise",
      "Alice  Cobbina -Anna Asante",
      "Gifty keelson	Ideal Barries Enterprise"
  ],

  MPOHOR: [
    "TOUGH SEED	TOUGH SEED",
        "TABAS SAKIW -TABAS SAKIW",
        "EVERGREEN ENT	EVERGREEN ENT",
        "VICTORIA SAM VENTURES",
        "BETTY BEE 72",
        "NESTKUM -NESTKUM",
        "JOSEPH MENSAH	HARMONIC BLESSINGS",
        "PAULMART	PAULMART",
        "FA DREAM MAKER	FA DREAM MAKER",
        "BIG PHILIPOS -BIG PHILIPOS",
        "BRIGHT TWUMASI	TB NYAME NE HENE",
        "FRETON VENTURES -FRETON VENTURES",
        "HANNAH BOTCHWAY -HANNAH BOTCHWAY'S GLORY",
  ],
};
